export default "/_next/static/images/caregiver3-e630b0628259a6fb7a8eabb75d232724.png";